import Checkmark from '@CS/assets/checkmark.svg?no-inline';
import styled, { css } from 'styled-components';

const CheckboxMargin = '12px';
const CheckboxSize = '24px';

export const FormContainer = styled.form`
  position: relative;
  max-width: 375px;
  display: block;

  width: 100%;
  padding: 0;
  margin: 0;
`;

export const SectionTitle = styled.h6`
  margin: 0.75em 0 1.5em;
  line-height: 1.5rem;

  color: rgb(0 0 0);
  font-weight: 700;
  font-size: 1rem;
`;

export const FieldsContainer = styled.div`
  justify-content: space-between;
  align-content: space-between;

  align-items: baseline;
  flex-direction: row;

  flex-wrap: wrap;
  display: flex;
`;

export const Separator = styled.hr`
  border: 1px solid rgb(191 191 191);
  margin: 1.5em 0 0.75em;
  width: 100%;
  height: 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const TermsContainer = styled.div`
  align-content: center;
  margin: 0.75em 0 1em;
  position: relative;

  flex-wrap: wrap;
  display: flex;
`;

type CheckboxAttributes = {
  checked?: boolean;
};

export const Checkbox = styled.input(
  ({ checked }: CheckboxAttributes) => css`
    margin: 0 ${CheckboxMargin} 0 0;
    border: 1px solid rgb(34 34 34);
    transition: border-color 0.3s;

    height: ${CheckboxSize};
    width: ${CheckboxSize};

    position: relative;
    border-radius: 5px;
    appearance: none;

    overflow: hidden;
    display: block;

    &::after {
      background-color: rgb(191 191 191);
      transition: background-color 0.3s;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      pointer-events: none;
      position: absolute;
      display: block;

      height: 100%;
      width: 100%;
      content: '';

      ${checked &&
      css`
        background-image: url(${Checkmark});
      `}
    }

    &:focus,
    &:active {
      border-color: rgb(0 0 0);

      &::after {
        background-color: rgb(255 255 255);
      }
    }
  `
);

export const TermsLabel = styled.label`
  flex-basis: calc(100% - ${CheckboxSize} - ${CheckboxMargin});
  color: rgb(191 191 191);
  line-height: 1.125rem;

  font-size: 0.875rem;
  position: relative;

  letter-spacing: 0;
  display: block;
`;

export const TermsLink = styled.a`
  text-decoration: underline;
  color: rgb(255 255 255);
  display: inline-block;
  position: relative;
`;
